import {createApp} from 'vue'

import Swal from "sweetalert2"
import Toggle from '@vueform/toggle'

const $generatorForPdfApp = createApp({
        name: "generatorForPdfAdmin",
        data() {
            return {
                scene: null,
                loading: false,
                unsavedKey: false,
                apiKey: generatorForPdfSettings.settings.apiKey,
                settings: generatorForPdfSettings.settings,
                postTypes: generatorForPdfSettings.postTypes,
                templates: generatorForPdfSettings.templates,
                usage: {
                    used: 0,
                    available: 0,
                },
                pageBuilders: {
                    gutenberg: {
                        slug: 'gutenberg',
                        label: 'Gutenberg',
                        enabled: false,
                    },
                    elementor: {
                        slug: 'elementor',
                        label: 'Elementor',
                        enabled: true,
                    },
                    bricks: {
                        slug: 'bricks',
                        label: 'Bricks',
                        enabled: false,
                    },
                    wpBakery: {
                        slug: 'wpbakery',
                        label: 'WPBakery',
                        enabled: false,
                    },
                    divi: {
                        slug: 'divi',
                        label: 'Divi',
                        enabled: false,
                    },
                    beaverBuilder: {
                        slug: 'beaver-builder',
                        label: 'Beaver Builder',
                        enabled: false,
                    },

                }
            }
        },
        mixins: [],
        computed: {

        },
        watch: {
            settings: {
                handler(newVal, oldVal) {
                    //console.log('Something was updated', newVal);
                    this.unsaved = true;
                },
                deep: true,
            },
            apiKey: {
                handler(newVal, oldVal) {
                    this.unsavedKey = true;
                },
            }

        },
        methods: {
            setScene(scene) {
                this.scene = scene;
            },

            async saveSettings() {

                let app = this;

                this.loading = true;

                jQuery.ajax({
                    type : "post",
                    dataType : "json",
                    url : generatorForPdf.ajaxUrl,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-WP-Nonce', generatorForPdf.nonce);
                    },
                    data:{
                        'action': 'generator_for_pdf_save_settings',
                        'settings': app.settings,
                    },
                    success: function(data){
                        Swal.fire({
                            icon: 'success',
                            title: 'Saved',
                            text: 'Your settings was saved.',
                            confirmButtonText: 'Ok',
                        }).then((result) => {
                            app.loading = false;
                        })
                    }
                });

            },

            addTemplate() {
                this.settings.templates.push({
                    postType: {
                        name: null,
                        label: null,
                    },
                    template: {
                        id: null,
                        label: null,
                    }
                });
            },
            deleteTemplate(index) {
                this.settings.templates.splice(index, 1);
            }


        },
        mounted: function () {

            this.setScene('pdf');

            let htmlTag = document.querySelector('html');
            htmlTag.classList.add('webien-ready');

        },
        created() {

        },
        components: {
            Toggle
        },
    });


// Mount app to DOM
window.$generatorForPdfApp = $generatorForPdfApp.mount('#generator-for-pdf-dashboard');
